import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./Dashboard.css";
import DashboardNavigation from "./../../components/Dashboard-comp/DashboardNavigation";
import DashboardContent from "../../components/Dashboard-comp/DashboardContent";
import ComingSoon from "./../../components/ComingSoon";

const CustomerList = () => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="col-md-12 content">
      <Sidebar
        className="sidebar-main"
        isActive={isActive}
        setIsActive={setIsActive}
        classNameTwo="open-sidebar"
      />
      <div className="col-12 sb-content">
        <div className="sb-content-header">
          <Header setIsActive={setIsActive} />
        </div>
        <div className="sb-nav">
          <DashboardNavigation />
        </div>
        <div className="content-index">
          <DashboardContent />
        </div>
      </div>
    </div>
  );
};

export default CustomerList;
